export function getSearchType(path: string) {
    const pathRegex = /for-sale|to-rent|new-homes/;

    const searchType = path.match(pathRegex);

    if (searchType) {
        return searchType[0];
    }

    return 'for-sale';
}
